import React from "react";
import NavbarProgram from "../../components/NavbarProgram";
import { Helmet } from "react-helmet";
import { googleFormEnglish } from "../../constant";
import { programData, ProgramType } from "../../data/programData";
import PaymentSection from "../../components/paymentSection";
import ServiceProcess from "../../components/serviceProcess";

const cvFeatures = [
  {
    title: "Strategic Career Feedback",
    description:
      "Beyond simple proofreading, we provide strategic guidance tailored to your career path. Analyze key industry keywords and position your experience effectively.",
  },
  {
    title: "Section-specific Comments",
    description:
      "Detailed feedback on Education, Experience, Skills sections according to UK recruitment standards.",
  },
  {
    title: "Native-level Polishing",
    description: "Experts refine grammar, style, and vocabulary to meet UK standards.",
  },
  {
    title: "Layout & Formatting",
    description: "Enhance readability and professional appearance with optimized layout.",
  },
  {
    title: "Improvement Strategy",
    description: "Receive actionable suggestions for future CV updates.",
  },
];

const ProgramCV: React.FC = () => {
  const program = programData.find((p) => p.id === ProgramType.CV)!;

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>BeMe – CV Consulting Program</title>
        <meta
          name="description"
          content="BeMe CV consulting: expert 1:1 feedback for international students entering the UK job market."
        />
      </Helmet>

      <NavbarProgram />

      {/* Hero Section */}
      <section className="bg-main text-white py-20 px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">CV / Resume Consulting</h1>
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-sub/90 mb-8">
          Not just proofreading—strategic UK-style feedback to craft a career-ready CV.
        </p>
        <a
          href={googleFormEnglish}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-accent text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-yellow-600 transition-colors"
        >
          Apply Now
        </a>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-sub">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-main text-center mb-12">What You Get</h2>
          <div className="grid md:grid-cols-2 gap-10">
            {cvFeatures.map((feature, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-main mb-2">{feature.title}</h3>
                <p className="text-gray-700">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 px-4 text-center">
        <ServiceProcess label={program.label} />
      </section>

      <section className="bg-sub py-20 px-4 text-center">
        <PaymentSection program={program} />
      </section>
    </div>
  );
};

export default ProgramCV;
